module.exports = __webpack_public_path__ + "images/658eed043b35ae23b714fa8bad2d91afa89cd03dacc1ff12799b86da37fc957a.svg";